<template>
  <div>
    <el-popover
        :popper-class="msgPopperClass"
        trigger="hover">
      <div class="is-error-msg">
        {{ errorMsg }}
      </div>
      <el-radio-group
          ref="input"
          slot="reference"
          v-model="inputValue"
          :value="inputValue"
          :size="size"
          :disabled="disabled"
          :text-color="textColor"
          :fill="fill"
          @change="updateCheckedValue">
        <template v-if="button">
          <el-radio-button v-for="(data, index) in radioList"
              :key="index"
              :label="data[optionsLabelKey]"
              :disabled="data[optionsDisabledKey]">
            {{ data[optionsViewLabelKey] }}
          </el-radio-button>
        </template>
        <template v-else>
          <el-radio v-for="(data, index) in radioList"
              :key="index"
              :label="data[optionsLabelKey]"
              :disabled="data[optionsDisabledKey]"
              :border="data[optionsBorderKey]"
              :size="data[optionsSizeKey]">
            {{ data[optionsViewLabelKey] }}
          </el-radio>
        </template>
      </el-radio-group>
    </el-popover>
    <div v-show="!popoverErrorMsg && errorMsg"
        class="is-error-msg">
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>
import ValidCore from '@/components/atoms/BaseValidCore'

export default {
  name: 'BaseValidRadio',
  mixins: [ValidCore],
  props: {
    //  Attributes
    size: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    fill: { type: String, default: undefined },
    textColor: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
    button: { type: Boolean, default: false },
    radioList: {
      type: Array,
      default: function () {
        return []
      }
    },
    optionsLabelKey: { type: String, default: 'code' },
    optionsViewLabelKey: { type: String, default: 'name' },
    optionsDisabledKey: { type: String, default: 'disabled' },
    optionsBorderKey: { type: String, default: 'border' },
    optionsSizeKey: { type: String, default: 'size' }
    /*
    radioList = [{
      label: {},
      disabled: Boolean,
      border: Boolean,
      size: String,
      viewLabel: String
    }, ...]
    */
  },
  methods: {
    // 親からインプット要素をフォーカスするために使われる
    focus: function () {
      this.$refs.input.$el.focus()
    }
  }
}
</script>
